// src/assets/data/coursesDetail.js
import bannerFinanzas_es from "../courses/finanzas.webp";
import bannerFinanzas_pt from "../courses/finanzaspt.png";
import bannerCripto_es from "../courses/presupuesto-ahorro.webp";
import bannerCripto_pt from "../courses/presupuesto-ahorropt.png";

export const coursesDetail = [
  {
    id: "finanzas-personales",
    title: "Finanzas Personales para Jóvenes Mexicanos",
    banners: {
      es: bannerFinanzas_es,
      pt: bannerFinanzas_pt,
    },
    description: `
      Este curso está pensado para jóvenes estudiantes mexicanos, universitarios o por ingresar a la universidad, que quieren aprender a manejar su dinero de forma consciente, aunque nunca hayan recibido educación financiera formal.
  
      A través de lecturas breves, ejemplos reales y actividades prácticas, te ayudaremos a construir una base sólida de finanzas personales para tomar decisiones más seguras y responsables.
    
      No hay videos: tú marcas el ritmo, leyendo y aplicando lo aprendido directamente en tu vida.
    `,
    modules: [
      {
        id: "modulo-1",
        title: "Introducción a las Finanzas Personales",
        duration: "1 hr",
      },
      { id: "modulo-2", title: "Presupuesto Inteligente", duration: "2 hr" },
      { id: "modulo-3", title: "Ahorro con Propósito", duration: "2 hr" },
      {
        id: "modulo-4",
        title: "Uso Responsable del Crédito",
        duration: "2 hr",
      },
      {
        id: "modulo-5",
        title: "Introducción a la Inversión",
        duration: "2 hr",
      },
      {
        id: "modulo-6",
        title: "Consumo Responsable y Hábitos Financieros",
        duration: "2 hr",
      },
      { id: "modulo-7", title: "Evaluación Final", duration: "30–45 min" },
    ],
    extras: [
      "Crear tu primer presupuesto personalizado",
      "Ahorrar con propósito y metas claras",
      "Usar el crédito de forma responsable y sin endeudarte",
      "Invertir paso a paso, aunque nunca lo hayas hecho",
      "Mejorar tus hábitos de consumo",
      "Tomar decisiones financieras alineadas a tus objetivos de vida",
    ],
    details: {
      rating: 5,
      totalDuration: "12 horas",
      modality: "Online, asincrónica",
      level: "Principiante",
      //   certification: "Profesional al finalizar",
    },
  },
  {
    id: "cripto-blockchain",
    title: "Introducción al Mundo Cripto y Blockchain",
    banners: {
      es: bannerCripto_es,
      pt: bannerCripto_pt,
    },
    description: `
      Este curso ofrece un recorrido práctico, visual y amigable por los fundamentos de Web3, las criptomonedas y la tecnología blockchain. Está especialmente diseñado para estudiantes de la Gen Z que desean entender este nuevo paradigma digital desde cero y con un enfoque claro, actual y útil.

      A través de ejemplos, herramientas y casos reales, aprenderás qué es Web3, cómo funcionan las criptos, qué es blockchain, cómo usar una wallet con seguridad y cómo navegar este ecosistema de forma inteligente y responsable. No necesitás conocimientos previos, solo curiosidad y ganas de aprender sobre el futuro de internet y las finanzas.
    `,
    modules: [
      {
        id: "modulo-1",
        title: "¿Qué es Web3 y por qué importa?",
        duration: "1 hr",
      },
      {
        id: "modulo-2",
        title: "Blockchain para principiantes",
        duration: "1 hr 30 min",
      },
      {
        id: "modulo-3",
        title: "Bitcoin, Ethereum, Solana, Cardano, Polygon y Stellar",
        duration: "1 hr 30 min",
      }, // – Las Grandes Ligas del Cripto
      {
        id: "modulo-4",
        title: "Stablecoins, Tokens y el Mundo Real del Cripto",
        duration: "1 hr",
      },
      {
        id: "modulo-5",
        title: "Seguridad en Web3 – Protege tus criptoactivos",
        duration: "1 hr 30 min",
      },
      {
        id: "modulo-6",
        title: "DeFi, NFTs y otras palabras raras",
        duration: "1 hr 30 min",
      },
      {
        id: "modulo-7",
        title: "Aprender y ganar cripto",
        duration: "45 min",
      },
      {
        id: "modulo-8",
        title: "Glosario y MiniConceptos Esenciales",
        duration: "30 min",
      },
      { id: "modulo-9", title: "Evaluación Final", duration: "30–45 min" },
    ],
    extras: [
      "Entender qué es Web3 y cómo cambia internet",
      "Comprender cómo funciona blockchain y qué lo hace seguro",
      "Diferenciar entre cripto, tokens, stablecoins y plataformas",
      "Usar wallets y proteger tus criptoactivos",
      "Detectar estafas y participar en proyectos reales con confianza",
    ],
    details: {
      rating: 5,
      totalDuration: "10 horas",
      modality: "Online, asincrónica",
      level: "Principiante",
      //   certification: "Profesional al finalizar",
    },
  },
  // …otros cursos
];
